import { memo } from "react";
import { areEqual, ListChildComponentProps } from "react-window";

import { ListEntitiesBaseItemProps } from "components/ListEntitiesNew";
import { PolicyEvaluationRecord } from "types/generated";

import PoliciesListItem from "./Item";

type PoliciesListVirtualizedItemProps = {
  items: PolicyEvaluationRecord[];
  canManagePolicies: boolean;
  policyId: string;
};

const PolicyDetailsSamplesListVirtualizedItem = (
  props: ListChildComponentProps<PoliciesListVirtualizedItemProps & ListEntitiesBaseItemProps>
) => {
  const { index, style, data } = props;

  const handleSetRowHeight = (size: number) => data.setRowHeight(index, size);

  return (
    <div style={style}>
      <PoliciesListItem
        key={data.items[index].key}
        createdAt={data.items[index].timestamp}
        id={data.items[index].key}
        setRowHeight={handleSetRowHeight}
        outcome={data.items[index].outcome}
        policyId={data.policyId}
      />
    </div>
  );
};

export default memo(PolicyDetailsSamplesListVirtualizedItem, areEqual);
